import { WHATSAPP } from '../../constants';
import './howtobuy.css';

const steps = [
  { num: '1', title: 'Elegí tu necesidad o producto', desc: 'Navegá por las secciones o contanos directamente qué necesitás limpiar.' },
  { num: '2', title: 'Escribinos por WhatsApp', desc: 'Te asesoramos sobre el producto ideal, cómo usarlo y las opciones disponibles.' },
  { num: '3', title: 'Retirá en el local', desc: 'Pasantos por Avda. Uruguay 785, Santa Rosa. También consultanos por otras opciones.' },
];

function HowToBuy() {
  return (
    <section className="section howtobuy">
      <div className="container">
        <div className="howtobuy__header">
          <span className="section-label">Cómo comprar</span>
          <h2 className="section-title">Tres pasos simples</h2>
        </div>
        <div className="howtobuy__steps">
          {steps.map((s) => (
            <div key={s.num} className="howtobuy__step">
              <span className="howtobuy__num">{s.num}</span>
              <div>
                <h3 className="howtobuy__title">{s.title}</h3>
                <p className="howtobuy__desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="howtobuy__cta">
          <a href={WHATSAPP.url} target="_blank" rel="noreferrer" className="btn btn-whatsapp">
            Consultar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}

export default HowToBuy;
